(function (win) {
  "use strict";

  /**
   * IE11 Fix
   */
  if (!win.location.origin) {
    win.location.origin = win.location.protocol + "//" + win.location.hostname + (win.location.port ? ":" + win.location.port : "");
  }
  var env = "";
  var srcFile = "/dcom-iframe.js";
  Array.prototype.forEach.call(document.getElementsByTagName("script"), function (script) {
    if (script.src.indexOf(srcFile) > -1) {
      env = script.src.split(srcFile)[0];
    }
  });
  var dcom = new IFrame(getScriptEl(), env);
  //throttle the height change event so it doesn't get called 10+ times at start
  var throttledHeightChange = throttle(dcom.setFrameHeight, 50);
  function API(el) {
    var eventListeners = {};
    var eventSource = null;
    function initChannel() {
      el.addEventListener("load", function () {
        postMessage({
          eventType: "load"
        });
      }, false);
    }
    function createChannel(onEvent) {
      var channel = new MessageChannel();
      channel.port1.onmessage = onEvent;
      return channel;
    }
    function postMessage(obj) {
      el.contentWindow.postMessage(JSON.stringify(obj), "*", [createChannel(onEvent).port2]);
    }
    function onEvent(e) {
      var message = JSON.parse(e.data);
      if (eventSource === null && e.source !== undefined) {
        eventSource = e.source;
      }
      if (eventListeners[message.eventType] && typeof eventListeners[message.eventType].callback === "function") {
        var response = eventListeners[message.eventType].callback(message);
        if (response) {
          response.eventType = eventListeners[message.eventType].eventResponseType;
          postMessage(response);
        }
      }
      if (message.webview) {
        try {
          window.webkit.messageHandlers["DCOM_".concat(message.eventType)].postMessage(message);
        } catch (e) {
          console.log("Could not post to iOS DCOM_".concat(message.eventType), e);
        }
        try {
          Android["on".concat(message.eventType)](JSON.stringify(message));
        } catch (e) {
          console.log("Could not post to Android on".concat(message.eventType), e);
        }
      }
    }

    /**
     * Only allows for one event listener callback per event type
     * @param {string}   type [name of the event]
     * @param {Function} cb   [callback for the type]
     * @param {string} [eventResponseType] name of the event to respond with
     */
    function addEventListener(type, cb, eventResponseType) {
      eventListeners[type] = {
        callback: cb,
        eventResponseType: eventResponseType || type
      };
    }
    return {
      onEvent: onEvent,
      initChannel: initChannel,
      addEventListener: addEventListener,
      postMessage: postMessage
    };
  }
  function CTA(container) {
    var cta = {};
    var isDisplayed = false;
    var tabletBreakpoint = 568;
    var embedWithScroll = false;
    var buttonPosition = "bottom";
    var absButton = null;
    var fixedButton = null;
    var headerOffset = {
      mobile: 0,
      tablet: 0
    };
    var absoluteHeaderOffset = {
      mobile: 0,
      tablet: 0
    };
    function createNumContainer() {
      return ['<span class="dcom-subtotal" style="display:inline-block;vertical-align:middle;margin:0;right:5px;top:8px;position: absolute;padding:2px 8px;">', '<div class="dcom-subtotal-overlay" style="position: absolute;top: -1px;left: 0;right: 0;bottom: 0px;border-radius: 2px; background: rgba(0,0,0,0.3);"></div>', '<span style="display:none" class="dcom-fixed-cta-items"></span>', '<span class="dcom-fixed-cta-total" style="font-size: 16px;position: relative;">$50.95</span>', "</span>"].join("");
    }
    function getButtons() {
      return document.getElementsByClassName("dcom-fixed-cta");
    }
    function getFixedButton() {
      return fixedButton ? fixedButton : fixedButton = document.getElementById("dcom-cta-fixed-button");
    }
    function getAbsoluteButton() {
      return absButton ? absButton : absButton = document.getElementById("dcom-cta-absolute-button");
    }
    function getCTAContainer() {
      return document.getElementById("dcom-cta-wrap");
    }
    function getMinimumEl() {
      return document.getElementsByClassName("dcom-fixed-cta-cart-minimum");
    }
    function onScrollHandler(frame) {
      var fixedBreakPoint = parseInt(container.offsetWidth <= tabletBreakpoint ? headerOffset.mobile : headerOffset.tablet, 10);
      if (frame.getBoundingClientRect().top < fixedBreakPoint) {
        getAbsoluteButton().style.display = "none";
        getFixedButton().style.display = "block";
      } else {
        getAbsoluteButton().style.display = "block";
        getFixedButton().style.display = "none";
      }
    }
    function setButtonsWidth() {
      var width = cta.getButtonWidth();
      getAbsoluteButton().style.width = width;
      getFixedButton().style.width = width;
    }
    function isButtonBottom() {
      return buttonPosition === "bottom";
    }
    cta.setButtonPosition = function (position) {
      buttonPosition = position;
    };

    /**
     * Offset from the top
     * @param offset
     */
    cta.setHeaderOffset = function (offset, absoluteOffset) {
      headerOffset = offset;
      absoluteHeaderOffset = absoluteOffset;
    };
    cta.setTabletBreakpoint = function (breakpoint) {
      tabletBreakpoint = parseInt(breakpoint, 10);
    };
    cta.setEmbedWithScroll = function (shouldScroll) {
      embedWithScroll = shouldScroll;
    };
    cta.addScrollListener = function (frame) {
      //set up the listener on the iframe top location
      window.addEventListener("scroll", onScrollHandler.bind(this, frame));
      onScrollHandler(frame);
    };
    cta.getButtonAnchor = function () {
      return document.getElementsByClassName("dcom-fixed-cta-anchor");
    };
    cta.getButtonWidth = function () {
      var padLeft = parseInt(win.getComputedStyle(container, null).getPropertyValue("padding-left"), 10) || 0;
      var padRight = parseInt(win.getComputedStyle(container, null).getPropertyValue("padding-right"), 10) || 0;
      var width = container.offsetWidth - padLeft - padRight;
      return container.offsetWidth < tabletBreakpoint && isButtonBottom() ? "100vw" : width + "px";
    };

    //button left offset should get the offset of the container relative to the window
    cta.getButtonLeftOffset = function () {
      var left = !isButtonBottom() ? container.getBoundingClientRect().left : parseInt(win.getComputedStyle(container, null).getPropertyValue("margin-left"), 10) || 0;
      return left + "px";
    };
    cta.getButtonWrapStyles = function () {
      return "background-color:#fff;border-bottom:1px solid #eee; text-align: right;padding: 5px 10px;box-sizing:border-box;box-shadow:0 0 3px rgb(0, 0, 0, 0.3);";
    };
    cta.getButtonStyles = function () {
      return "<style>" + ".dcom-fixed-cta-anchor{width:100%;position:relative;background-color:#ea6a00;color:white;overflow: hidden;padding:9px 10px 9px 35px;border:none;border-radius:3px;cursor:pointer;font-size:16px;font-weight:bold;line-height:22px;outline: 0;display:block;box-sizing:border-box;white-space:nowrap;text-align:center;font-family: Arial, sans-serif;}" + ".dcom-fixed-cta-cart-minimum{margin-top:5px;text-align: center;color:#666666;font-family:Arial,sans-serif;font-size:15px;}" + ".dcom-fixed-cta-cart-minimum--tablet{font-size:16px;}" + "#dcom-cta-fixed-button{position:fixed;display: none;z-index:100000;".concat(buttonPosition, ":").concat(headerOffset.mobile, "px}") + "@media (min-width: 960px){ .dcom-fixed-cta{display:none !important;} }" + "</style>";
    };
    cta.createAbsoluteButton = function () {
      var position = container.offsetWidth < tabletBreakpoint ? absoluteHeaderOffset.mobile : absoluteHeaderOffset.tablet;
      var wrapStyles = cta.getButtonWrapStyles() + "position:absolute;display: none;z-index:100000;" + buttonPosition + ":" + position + ";width:" + cta.getButtonWidth();
      return cta.createButton(wrapStyles, cta.getButtonStyles(), "dcom-cta-absolute-button");
    };
    cta.createFixedButton = function () {
      var wrapStyles = cta.getButtonWrapStyles() + ";left:" + cta.getButtonLeftOffset() + ";width:" + cta.getButtonWidth();
      return cta.createButton(wrapStyles, cta.getButtonStyles(), "dcom-cta-fixed-button");
    };
    cta.setFixedButtonStyles = function () {
      var position = container.offsetWidth < tabletBreakpoint ? headerOffset.mobile : headerOffset.tablet;
      document.getElementById("dcom-cta-fixed-button").style[buttonPosition] = position + "px";
    };
    cta.setFixedCartMinStyles = function () {
      var className = "dcom-fixed-cta-cart-minimum--tablet";
      Array.prototype.forEach.call(document.getElementsByClassName("dcom-fixed-cta-cart-minimum"), function (el) {
        if (container.offsetWidth < tabletBreakpoint) {
          if (el.classList) {
            el.classList.remove(className);
          } else {
            el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
          }
        } else {
          if (el.classList) {
            el.classList.add(className);
          } else {
            el.className += " " + className;
          }
        }
      });
    };
    cta.createButton = function (wrapStyles, styles, buttonId) {
      return ['<div class="dcom-fixed-cta" style="' + wrapStyles + '" id="' + buttonId + '">', styles, '<button class="dcom-fixed-cta-anchor">', cta.getBagSVG(), '<span style="font-size:14px;display:inline-block;vertical-align:middle;" class="dcom-fixed-cta-label"></span> ', createNumContainer(), "</button>", '<div class="dcom-fixed-cta-cart-minimum cart-minimum"></div>', "</div>"].join("");
    };
    cta.getBagSVG = function () {
      return ['<svg class="icon icon-shopping-bag" preserveAspectRatio="none" viewBox="0 0 28 34" style="position: absolute;left: 10px;top: 8px;vertical-align: middle;margin-right:10px;width:18px;display:inline-block;height: 24px;stroke-width: 0;stroke: #fff;fill: #fff;">', "<title>shopping-bag</title>", '<path class="path1" d="M28.256 30.721c0 0 0-0.048 0-0.048-0.048-8.977-0.724-17.424-0.965-20.513 0 0 0-0.048 0-0.048-0.097-0.676-0.627-1.158-1.351-1.158 0 0 0 0 0 0v0h-2.027l0.338 3.234c0 0.048 0 0.097 0 0.097 0 0.917-0.724 1.641-1.641 1.641s-1.641-0.724-1.641-1.641c0-0.579 0.338-1.11 0.821-1.4 0.097 0.869 0.097 1.448 0.097 1.448 0 0.386 0.338 0.724 0.724 0.724v0c0.386 0 0.724-0.338 0.724-0.724 0-0.29-0.048-7.336-3.379-10.667-1.158-1.158-2.558-1.689-4.151-1.689-1.641 0-3.041 0.579-4.151 1.738-1.786 1.882-2.558 4.875-2.848 7.192h-2.751c0 0-0.048 0-0.048 0-0.676 0-1.207 0.483-1.351 1.11 0 0.048-0.048 0.097-0.048 0.145-0.29 3.089-0.965 11.487-0.965 20.416 0 0 0 0 0 0.048 0 0 0 0 0 0.048 0 0 0 0 0 0.048 0 0 0 0 0 0 0.048 0.724 0.627 1.255 1.351 1.255 0 0 0 0 0.048 0v0h21.912c0 0 0 0 0 0s0 0 0 0v0 0c0.724 0 1.255-0.579 1.303-1.255zM11.17 8.953l-0.241 3.475c-0.048 0.869-0.772 1.544-1.641 1.544-0.917 0-1.641-0.724-1.641-1.641 0-0.676 0.386-1.207 0.965-1.496-0.048 0.821-0.048 1.4-0.048 1.448 0 0.386 0.386 0.724 0.772 0.724s0.724-0.338 0.724-0.772c0-0.048-0.145-6.612 2.655-9.46 0.869-0.869 1.882-1.303 3.089-1.303 2.462 0 4.199 1.738 5.213 5.261 0.241 0.772 0.386 1.496 0.531 2.22h-10.377z"></path>', "</svg>"].join("");
    };
    cta.onButtonClick = function (cb) {
      Array.prototype.forEach.call(getButtons(), function (btn) {
        btn.addEventListener("click", cb);
      });
    };
    cta.insert = function (el, buttonPosition) {
      el.insertAdjacentHTML("afterbegin", '<div id="dcom-cta-wrap" style="display: none;">' + cta.createAbsoluteButton(buttonPosition) + cta.createFixedButton(buttonPosition) + "</div>");
    };
    cta.setButtonVisibility = function (visibility) {
      var container = getCTAContainer();
      container.style.display = visibility;
      container = null;
      isDisplayed = !isDisplayed;
    };
    cta.hide = function () {
      if (isDisplayed) {
        cta.setButtonVisibility("none");
        if (buttonPosition === "bottom") {
          getFixedButton().style.display = "none";
        }
      }
    };
    cta.show = function () {
      if (!isDisplayed) {
        cta.setButtonVisibility("block");
        if (buttonPosition === "bottom") {
          getFixedButton().style.display = "block";
        }
      }
    };
    cta.setStyles = function (buttons, styleObj) {
      Object.keys(styleObj).forEach(function (prop) {
        Array.prototype.forEach.call(buttons, function (button) {
          button.style[prop] = styleObj[prop];
        });
      });
    };
    cta.setLabel = function (text) {
      if (text && text.length) {
        Array.prototype.forEach.call(document.getElementsByClassName("dcom-fixed-cta-label"), function (el) {
          el.innerHTML = text;
        });
      }
    };
    cta.setTotal = function (total) {
      Array.prototype.forEach.call(document.getElementsByClassName("dcom-fixed-cta-total"), function (el) {
        el.innerHTML = total;
      });
    };
    cta.setItems = function (items) {
      Array.prototype.forEach.call(document.getElementsByClassName("dcom-fixed-cta-items"), function (el) {
        el.innerHTML = items;
      });
    };
    cta.setMinimum = function (text) {
      Array.prototype.forEach.call(getMinimumEl(), function (el) {
        el.innerHTML = text;
      });
    };
    cta.setMinVisibility = function (visibility) {
      Array.prototype.forEach.call(getMinimumEl(), function (el) {
        if (el) {
          el.style.display = visibility;
        }
      });
    };
    cta.showTotal = function () {
      Array.prototype.forEach.call(document.getElementsByClassName("dcom-subtotal"), function (el) {
        if (el) {
          el.style.display = "inline-block";
        }
      });
    };
    cta.hideTotal = function () {
      Array.prototype.forEach.call(document.getElementsByClassName("dcom-subtotal"), function (el) {
        if (el) {
          el.style.display = "none";
        }
      });
    };
    cta.showMinimum = function () {
      cta.setMinVisibility("block");
    };
    cta.hideMinimum = function () {
      cta.setMinVisibility("none");
    };
    window.addEventListener("resize", function () {
      setButtonsWidth();
      cta.setFixedButtonStyles();
      cta.setFixedCartMinStyles();
      document.getElementById("dcom-cta-fixed-button").style.left = cta.getButtonLeftOffset();
    });
    return cta;
  }
  function IFrame(container, env) {
    var cta;
    var frame = {
      config: {},
      insert: insert,
      cta: cta,
      getFrame: getFrame,
      onFixedButtonClick: onFixedButtonClick,
      setFrameHeight: setFrameHeight,
      displayFixedButton: displayFixedButton,
      api: null //to be assigned on init
    };

    //discount code query needs to be called cq in app (no clue why)
    var optionNameMap = {
      discount: "cq",
      "embedded-in-webview": "embeddedInWebView"
    };
    function mapNewName(option) {
      return optionNameMap[option] || option;
    }
    function tagsToQueryString(tag, url, widget) {
      return url + Object.keys(tag.dataset).map(function (option) {
        // Address, lat, and long options for 'Search' and 'ChoiceHotels' widget is mapped in getURLForWidget so return empty string here
        return (widget === "Search" || widget === "ChoiceHotels") && (option === "address" || option === "lat" || option === "long") ? {
          key: null,
          el: null
        } : {
          key: option,
          el: tag.dataset[option]
        };
      }).filter(function (option) {
        return option.el !== null;
      }).map(function (option) {
        updateConfig(option);
        return option;
      }).map(function (option) {
        return mapNewName(option.key) + "=" + encodeURIComponent(option.el);
      }).join("&");
    }
    function updateConfig(option) {
      frame.config[option.key] = option.el;
    }

    /**
     * Return the relevant starting url based on Widget specified by SDK
     * @param tag {HTML element}
     * @param env {string}
     * @param widget {string}
     */
    function getUrlForWidget(tag, env, widget) {
      var queryStart = "/?parentSite=" + encodeURIComponent(win.location.origin) + "&";
      if (widget === "Search" || widget === "ChoiceHotels") {
        var resultsRoute = "/results";
        var searchRoute = "/search";
        var choiceRoute = "/choice";
        var startingRoute = hasResultsPageOptions(tag) ? resultsRoute : widget === "Search" ? searchRoute : choiceRoute;
        queryStart += stringifyAddressLatLongAndOrderType(tag);
        return env + startingRoute + queryStart + "widget=" + widget.toLowerCase() + "&";
      }
      var merchantId = tag.src.replace(/^[^\?]+\??/, "");
      return env + "/merchants/" + merchantId + queryStart;
    }

    /*
     * If SDK is setup for laundry - user only needs to specify address
     * else - user needs address AND order type in order to start on results page.
     */
    function hasResultsPageOptions(tag) {
      var address = tag.getAttribute("data-address");
      var orderType = tag.getAttribute("data-order-type");
      var lat = tag.getAttribute("data-lat");
      var _long = tag.getAttribute("data-long");
      var hasLocation = address || lat && _long;
      return tag.getAttribute("data-laundry") ? hasLocation : hasLocation && orderType;
    }
    function stringifyAddressLatLongAndOrderType(tag) {
      var query = ["address", "order-type", "lat", "long"].map(function (option) {
        return {
          attr: mapNewName(option),
          value: tag.getAttribute("data-" + option)
        };
      }).filter(function (attrObj) {
        return attrObj.value;
      });
      return query.reduce(function (prev, next) {
        return prev += next.attr + "=" + encodeURIComponent(next.value) + "&";
      }, "");
    }

    /**
     * Insert the iFrame into a given container
     * @param parent {HTMLElement}
     */
    function insert(parent) {
      var el = document.createElement("div");
      var widget = parent.getAttribute("data-widget");
      var widgetUrl = getUrlForWidget(parent, env, widget);
      var url = tagsToQueryString(parent, widgetUrl, widget);
      el.innerHTML = '<iframe style="width:100%;height:1700px" src="' + url + '" frameborder="0" scrolling="no" id="dcom-iframe"></iframe>';
      parent.parentNode.insertBefore(el, parent.nextSibling);
    }

    /**
     * CTA Button click event listener
     */
    function onFixedButtonClick() {
      frame.api.postMessage({
        eventType: "fixedButtonClicked"
      });
    }

    /**
     * Get the iFrame element on the page
     * @returns {Element}
     */
    function getFrame() {
      return document.getElementById("dcom-iframe");
    }

    /**
     * Set the height of an element (presumably the iFrame)
     * @param height {number}
     */
    function setFrameHeight(height) {
      getFrame().style.height = height + "px";
    }
    function displayFixedButton(data) {
      cta.setLabel(data.label);
      cta.setItems(data.quantity + " item" + (data.quantity > 1 ? "" : "s"));
      cta.setTotal("$" + data.amount.toFixed(2));
      if (!data.amount) {
        cta.hideTotal();
      } else {
        cta.showTotal();
      }
      cta.show();
      // For minimum copy. Show and hide.
      if (data.minimum > 0 && data.remaining > 0 && (data.isLaundry || !data.isCheckout)) {
        var copy = (data.isLaundry ? "Minimum order is " : "Subtotal must exceed ") + "$".concat(data.minimum, ".00");
        var laundryCopy = data.isLaundry ? '<div class="laundry-disclaimer">(You can order less but may be charged the min.)</div>' : "";
        cta.setMinimum(copy + laundryCopy);
        cta.showMinimum();
      } else {
        cta.hideMinimum();
      }
    }
    function getEmbedParentSelector() {
      return container.getAttribute("data-embedquery");
    }
    function getButtonPositionSetting() {
      return container.getAttribute("data-buttonposition") || "bottom";
    }
    function getFixedHeaderOffset() {
      return {
        mobile: parseInt(container.getAttribute("data-mobile-fixed-header-offset") || 0, 10),
        tablet: parseInt(container.getAttribute("data-tablet-fixed-header-offset") || 0, 10)
      };
    }
    function getAbsoluteHeaderOffset() {
      return {
        mobile: parseInt(container.getAttribute("data-mobile-absolute-header-offset") || 0, 10),
        tablet: parseInt(container.getAttribute("data-tablet-absolute-header-offset") || 0, 10)
      };
    }
    function getTabletBreakpoint() {
      return container.getAttribute("data-tablet-breakpoint") || 568;
    }
    function getCTAEmbedLocation(selector) {
      return document.querySelectorAll(selector || "body")[0];
    }
    function init() {
      insert(container);
      var selector = getEmbedParentSelector();
      var embedContainer = getCTAEmbedLocation(selector);
      var buttonPosition = getButtonPositionSetting();
      cta = new CTA(embedContainer);
      frame.cta = cta;
      cta.setEmbedWithScroll(!!selector);
      cta.setButtonPosition(buttonPosition);
      cta.setHeaderOffset(getFixedHeaderOffset(), getAbsoluteHeaderOffset());
      cta.setTabletBreakpoint(getTabletBreakpoint());
      cta.insert(embedContainer, buttonPosition);
      cta.setFixedButtonStyles();
      cta.setFixedCartMinStyles();
      if (!!selector && buttonPosition === "top") {
        cta.addScrollListener(getFrame());
      }
      cta.onButtonClick(onFixedButtonClick);
      frame.api = new API(getFrame());
      frame.api.initChannel();
    }
    init();
    return frame;
  }

  /**
   * Get the script tag on the page
   * @returns {Element}
   */
  function getScriptEl() {
    return document.querySelectorAll("[data-id=dcom-iframe-api]")[0];
  }

  /**
   * Returns the absolute x and y position of the given element
   * @param el
   * @returns {{x: number, y: number}}
   */
  function getPosition(el) {
    var position = el.getBoundingClientRect();
    return {
      x: Math.abs(position.left),
      y: Math.max(position.top * -1, 0)
    };
  }
  function throttle(fn, timeout) {
    var timer;
    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = win.setTimeout(function () {
        fn.apply(null, args);
      }, timeout);
    };
  }
  /**
   * Message Event Listeners
   */
  function onHeightChange(message) {
    throttledHeightChange(message.height);
  }
  function onGetPopupPosition() {
    return {
      top: getPosition(dcom.getFrame()).y + 40
    };
  }
  function onGetFramePosition() {
    return getPosition(dcom.getFrame());
  }
  function onGetViewport() {
    return {
      viewPort: {
        height: win.innerHeight
      }
    };
  }
  function onScrollTop(message) {
    var padding = message.noPad ? 0 : 80;
    var offset = parseInt(message.offset, 10);
    //40 for popup padding added,
    //40 for adding padding to scroll
    win.scrollTo(0, offset + padding);
  }
  function onSetFixedButtonState(message) {
    dcom.cta.setStyles(dcom.cta.getButtonAnchor(), {
      backgroundColor: message.buttonColor,
      cursor: message.cursorType
    });
    dcom.cta.setLabel(message.buttonText);
  }
  function onAnalyticsEvent(message) {
    if (dcom.config.microsites) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(message.item);
    }
  }
  dcom.api.addEventListener("setHeight", onHeightChange);
  dcom.api.addEventListener("getPopupPosition", onGetPopupPosition, "popupOffset");
  dcom.api.addEventListener("getViewport", onGetViewport);
  dcom.api.addEventListener("scrollTop", onScrollTop);
  dcom.api.addEventListener("displayFixedButton", dcom.displayFixedButton);
  dcom.api.addEventListener("hideFixedButton", dcom.cta.hide);
  dcom.api.addEventListener("setFixedButtonState", onSetFixedButtonState);
  dcom.api.addEventListener("analytics", onAnalyticsEvent);
  dcom.api.addEventListener("getFramePosition", onGetFramePosition, "framePosition");
  if (!win.dcomIframeApp) {
    win.dcomIframeApp = dcom.api;
  }
})(window);